<template>
  <!-- Pestaña 12 · Satisfacción y VoC — Fase 5 DIFERIDA. Oculta por el flag surveys. -->
  <exec-placeholder
    title="Satisfacción y voz del cliente — Fase 5 (diferida)"
    message="Las encuestas, CSAT/NPS y gestión de casos no están implementados todavía. Se habilitarán al activar el flag surveys en una fase posterior."
  />
</template>

<script>
import ExecPlaceholder from './ExecPlaceholder.vue';
// Pestaña 12 · Satisfacción y VoC (doc 04 §3, reporte 14). Diferida a Fase 5.
export default { name: 'ExecVoc', components: { ExecPlaceholder }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
